import { render, staticRenderFns } from "./InstagramCardContent.vue?vue&type=template&id=e82db88a&scoped=true&"
import script from "./InstagramCardContent.vue?vue&type=script&lang=js&"
export * from "./InstagramCardContent.vue?vue&type=script&lang=js&"
import style0 from "./InstagramCardContent.vue?vue&type=style&index=0&id=e82db88a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82db88a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VExpansionPanelContent,VIcon,VSlider,VTextField})
